import { Center } from "@/components/Center/Center";
import { useHandleError } from "@/hooks/useHandleError";
import { createDemoUser, isDemoMode } from "@/utils/demoUser";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import { usePointWithdrawals } from "@roman/shared/hooks/withdrawals/usePointWithdrawals";
import { useTotalWithdrawals } from "@roman/shared/hooks/withdrawals/useTotalWithdrawals";
import { getAuthenticatedUser } from "@roman/shared/store/auth.store";
import { pointsToMiraiMile } from "@roman/shared/utils/pointsToMiraiMile";
import { RecordCard } from "./Card";
import { MyGiftPoints } from "./components/MyGiftPoints";

export const WithdrawalRecord = () => {
  const handleError = useHandleError("ポイント履歴の取得に失敗しました");
  const { data: records, isLoading } = usePointWithdrawals(handleError, isDemoMode());
  const { data: totalWithdrawals, isLoading: isTotalWithdrawalsLoading } = useTotalWithdrawals(
    handleError,
    isDemoMode(),
  );
  const user = isDemoMode() ? createDemoUser() : getAuthenticatedUser();

  if (isLoading || !records || isTotalWithdrawalsLoading || !totalWithdrawals) {
    return (
      <Center>
        <LoadingSpinner />
      </Center>
    );
  }

  return (
    <div className="bg-white min-w-full min-h-screen">
      <MyGiftPoints
        myPoint={pointsToMiraiMile(user.redeemablePoints)}
        total={pointsToMiraiMile(totalWithdrawals.totalWithdrawnPoints)}
      />
      <div className="p-[30px] flex flex-col items-start gap-10">
        <div className="flex flex-col gap-4 w-full">
          {records.map((record, index) => {
            return <RecordCard key={index} record={record} />;
          })}
        </div>
      </div>
    </div>
  );
};
